/**
 * Build-time configuration.
 *
 * Vite inlines `import.meta.env` at build time, so everything here ends up in the bundle a browser
 * downloads. That is exactly why nothing secret may live in it: the API base URL and the
 * environment name are public facts, and anything else belongs on the server.
 */

export type AppEnvironment = 'local' | 'dev' | 'staging' | 'prod' | 'test';

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing ${name}. Copy dashboard/.env.example to dashboard/.env and fill it in before starting the dashboard.`,
    );
  }
  return value;
}

export interface AppConfig {
  readonly apiBaseUrl: string;
  readonly environment: AppEnvironment;
  /** True where extra diagnostics are acceptable; never in production. */
  readonly verbose: boolean;
}

export function readConfig(env: ImportMetaEnv = import.meta.env): AppConfig {
  const environment = (env.VITE_APP_ENV ?? 'local') as AppEnvironment;
  return {
    apiBaseUrl: required('VITE_API_BASE_URL', env.VITE_API_BASE_URL).replace(/\/+$/, ''),
    environment,
    verbose: environment !== 'prod',
  };
}
